export const C = {
  // Brand
  gold: '#FFD166',
  red: '#EF476F',
  green: '#06D6A0',
  blue: '#118AB2',
  purple: '#9B5DE5',

  // Backgrounds
  bg: '#07071A',
  card: '#12122A',
  card2: '#0D0D22',

  // Text
  white: '#ffffff',
  textSub: 'rgba(255,255,255,0.5)',
  textMuted: 'rgba(255,255,255,0.25)',

  // UI
  border: 'rgba(255,255,255,0.08)',
  inputBg: 'rgba(255,255,255,0.05)',
  inputBorder: 'rgba(255,255,255,0.12)',
};